import Typography from '@mui/material/Typography';
import { useTranslation } from '../../../../../language';

export const TextBmi = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="body1">
        <br />
        {t("vitals_info_intro")}
        <br /><br />
        <Typography component="span" variant="h6" sx={{ fontWeight: '600' }}>
          {t("vitals_info_bmi_heading")}
        </Typography>
        <br /><br />
        {t("vitals_info_bmi_body")}
        <br /><br />
        <Typography component="span" variant="h5" sx={{ fontWeight: '700' }}>
          {t("vitals_info_wc_heading")}
        </Typography>
        <br /><br />
        {t("vitals_info_wc_body")}
        <br /><br />
        {t("vitals_info_apple_pear")}
        <br /><br />
        {t("vitals_info_source")}:<br /><br />
        https://www.nhlbi.nih.gov/health/educational/lose_wt/BMI/bmicalc.htm<br />
        https://www.heartandstroke.ca/healthy-living/healthy-weight/healthy-weight-and-waist<br />
        https://www.cdc.gov/nchs/data/series/sr_02/sr02_182-508.pdf
      </Typography>
    </div>
  );
};
